(function () {
  const selector = '[data-scarlet-shipping-message]';

  function fxRate() {
    const r = window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate);
    return (r && isFinite(r) && r > 0) ? r : 1;
  }

  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
  }

  // SCARLET 02 Sep 2026: pin the locale per currency. Passing undefined uses the
  // shopper's browser language, so a Norwegian customer on an English browser saw
  // "NOK 6.75" instead of "6,75 kr".
  const LOCALE_BY_CURRENCY = {
    AUD: 'en-AU',
    NZD: 'en-NZ',
    GBP: 'en-GB',
    EUR: 'en-IE',
    CHF: 'de-CH',
    NOK: 'nb-NO'
  };

  // Intl gives the right symbol per currency (£, kr, CHF, €).
  // theme.formatMoney uses the shop's AUD format string, so it would print
  // a dollar sign to a UK customer.
  function formatMoney(minorUnits) {
    const amount = minorUnits / 100;
    const currency = activeCurrency();
    try {
      const out = new Intl.NumberFormat(LOCALE_BY_CURRENCY[currency] || undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);

      // en-NZ prints a bare $, which reads as AUD to an Australian shop.
      return currency === 'NZD' ? out.replace('$', 'NZ$') : out;
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function render(el, cartTotal) {
    const text = el.querySelector('[data-scarlet-shipping-text]');
    const progress = el.querySelector('[data-cart-progress]');
    const limitAud = Number(el.dataset.limitAud || 0);
    const limitFixed = Number(el.dataset.limitFixed || 0);
    const limitCurrency = el.dataset.limitCurrency || '';

    // SCARLET 29 Sep 2026: a fixed figure is the real number off the shipping
    // zone, already in the shopper's currency - print it untouched. Converting
    // an AUD figure by Shopify.currency.rate only ever approximates the zone,
    // and the approximation moves with the rate (the UK read 80.78, not 80).
    // Fall back to converting only when there is no fixed figure, or when the
    // shopper has switched to a currency it isn't written in.
    const useFixed = limitFixed > 0 && limitCurrency === activeCurrency();

    // Both sides of the comparison in the customer's currency, minor units.
    const limitLocal = useFixed ? limitFixed * 100 : limitAud * 100 * fxRate();

    if (!text || !limitLocal) return;

    if (cartTotal <= 0) {
      el.classList.add('is-hidden');
      return;
    }

    const gap = limitLocal - cartTotal;

    el.classList.remove('is-hidden');
    el.classList.toggle('is-success', gap <= 0);

    text.textContent = gap > 0
      ? 'You are ' + formatMoney(gap) + ' away from free shipping.'
      : 'Free shipping unlocked.';

    if (progress) {
      const percent = Math.max(0, Math.min((cartTotal / limitLocal) * 100, 100));
      progress.dataset.percent = String(percent);
      progress.style.setProperty('--percent', String(percent));
    }
  }

    // The UK 135 notice is server-rendered Liquid, so it cannot update itself
  // on an ajax cart change. Toggle it here using the same cart total.
  function renderUkNotice(cartTotal) {
    const wrap = document.querySelector('[data-uk-notices]');
    if (!wrap) return;

    const threshold = Number(wrap.dataset.ukThreshold || 0);
    if (!threshold) return;

    const over = cartTotal > threshold;
    const under = wrap.querySelector('[data-uk-under]');
    const above = wrap.querySelector('[data-uk-over]');

    if (under) under.classList.toggle('is-hidden', over);
    if (above) above.classList.toggle('is-hidden', !over);
  }

  let pending = null;

  function refresh() {
        if (!document.querySelector(selector) && !document.querySelector('[data-uk-notices]')) return;

    // Debounce - several cart events can fire for one user action.
    clearTimeout(pending);
    pending = setTimeout(function () {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('cart')); })
        .then(function (cart) {
          const total = Number(cart.total_price || 0);
          document.querySelectorAll(selector).forEach(function (el) {
            render(el, total);
          });
          renderUkNotice(total);
        })
        .catch(function (e) {
          console.warn('Scarlet free-shipping message could not refresh:', e);
        });
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

    // Shared with the add-to-cart tile in sections/product.liquid so both lines
  // format money the same way.
  window.ScarletFormatMoney = formatMoney;

  // The theme fires several different cart events depending on what changed -
  // quantity change, ajax add, drawer open. Listen to all of them.
  [
    'theme:cart',
    'theme:cart:add',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart:refresh',
    'theme:cart:toggle',
    'theme:product:added'
  ].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });

  // The ajax cart re-renders its HTML, which replaces our element with a fresh
  // blank one. Watch for that and re-fill it.
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(selector)) return refresh();
          if (node.querySelector && node.querySelector(selector)) return refresh();
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();